module.exports = __webpack_public_path__ + "static/media/gilroy-regular.93a118ae.otf";